import makeStyles from '@mui/styles/makeStyles';

const styles = (theme) => ({
    link: ({ commonUIStyles }) => {
        return {
            marginLeft: '10px',
            color: commonUIStyles.getPrimaryButtonColor(),
        };
    },
    
});

export default styles;
export const useStyles = makeStyles(styles);
